import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./Buy_Modal.css";

const BuyModal = ({ show, handleClose, handleDelete }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="delete-modal"
    >
      <Modal.Body className="delete-modal-body text-center">
        <h2>Please complete your profile</h2>

        <div className="delete-btn-group">
          <Button className="yes-btn" onClick={handleClose}>
            OK
          </Button>

          {/* <Button className="no-btn" onClick={handleDelete}>
            No
          </Button> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BuyModal;
